
import React from 'react';
import { connect } from 'react-redux';
import { getRateSheet, updateRateSheet, importCSV, getRateSheetCSV, addRateData, deleteRateData} from '../Dashboard/DashboardActions';
import BaseRateManagementWidget from '../../components/BaseRates/BaseRateManagementWidget';
import {  setBaseRateUi  } from './BaseRatesUiActions';

class BaseRatesManageContainer extends React.Component{

  render(){
    return (
      <BaseRateManagementWidget {...this.props}/>
    );
  }
}

const mapStateToProps = (state) => ({
  rateSheet: state.business.rateSheet,
  terminals: state.business.terminals,
  uiState: state.baseRateUi.baseRateUi.toObject(),
});


const mapDisptatchToProps = (dispatch) => ({ 
  dispatchImportCSV: (parameters, cb)  => dispatch(importCSV(parameters, cb)),
  getRateSheet: (parameters, callback) => dispatch(getRateSheet(parameters, callback)),
  updateRateSheet: (parameters, callback) => dispatch(updateRateSheet(parameters, callback)),
  setUiState: state => dispatch(setBaseRateUi(state)),
  dispatchGetRateSheetCSV: (params, cb) => dispatch(getRateSheetCSV(params, cb)),
  dispatchAddRateData: (params, cb) => dispatch(addRateData(params, cb)),
  dispatchDeleteRateData: (params, cb) => dispatch(deleteRateData(params, cb))
});



export default connect(mapStateToProps, mapDisptatchToProps)(BaseRatesManageContainer);


// WEBPACK FOOTER //
// ./src/containers/BaseRates/BaseRatesManageContainer.js